export enum SubjectFormat {
  ID = 'ID',
  MINI = 'MINI',
  SUMMARY = 'SUMMARY',
  FULL = 'FULL',
}
